var map = {
	"./Algorithms-Sort.json": 1371,
	"./Antidepressant Switching and Discontinuation.json": 6090,
	"./Antidepressant Switching.json": 6740,
	"./BMI (Adult).json": 9993,
	"./CKD-Epi.json": 4909,
	"./COWS.json": 177,
	"./Child-Pugh.json": 2785,
	"./ECG-QTC.json": 8254,
	"./Mood Stabilizer Switching and Discontinuation.json": 3867,
	"./Mood Stabilizer Switching.json": 3573,
	"./STOP BANG.json": 4893,
	"./acutestress.json": 1157,
	"./adhd.json": 9996,
	"./ainsom.json": 4330,
	"./algorithms.json": 3666,
	"./anorexia.json": 2257,
	"./antipsychotic_manage.json": 1562,
	"./aud.json": 6124,
	"./autism.json": 1064,
	"./benzo.json": 505,
	"./binge.json": 1337,
	"./bipolar_adult.json": 653,
	"./bulimia.json": 8206,
	"./cinsom.json": 8863,
	"./dem.json": 7876,
	"./depressive.json": 6578,
	"./diagnoses.json": 587,
	"./fibromyalgia.json": 6276,
	"./fsaid.json": 2909,
	"./gad.json": 7406,
	"./global.json": 7091,
	"./ied.json": 2407,
	"./medications.json": 2467,
	"./news.json": 4063,
	"./ocd.json": 9338,
	"./oud.json": 898,
	"./panic.json": 8340,
	"./pmdd.json": 2915,
	"./psychosis.json": 6210,
	"./ptsd.json": 1569,
	"./sad.json": 4601,
	"./schizophrenia.json": 6556,
	"./somatic.json": 5348,
	"./ssrisex.json": 1396,
	"./stimulant.json": 9659,
	"./tallMedications.json": 1820,
	"./team.json": 6547,
	"./therapy.json": 7032,
	"./toc.json": 5571,
	"./tud.json": 7558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6773;